import { useEffect, useRef } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import urljoin from 'url-join'

type Params = {
  menuGuid?: string
  itemSlug?: string
  groupSlug?: string
}

/**
 * A convenient hook for having your React Router based app scroll to the top of the page automatically on page navigation
 */
export const useScrollToTopOnNewLocation = () => {
  const { pathname, search, hash } = useLocation()
  const params = useParams<Params>()
  const lastLocationPath = useRef<string | null>(null)
  const lastSearchString = useRef<string | null>(null)
  // match both the /group_:groupGuid/item-:itemSlug_:itemGuid and /products/:itemSlug routes
  const isProductDisplayPage =
    (params.itemSlug && params.groupSlug) ||
    (params.itemSlug && pathname.includes(urljoin('products', params.itemSlug)))

  useEffect(() => {
    if (
      (lastLocationPath.current !== pathname ||
        lastSearchString.current !== search) &&
      ((!params.menuGuid && !params.itemSlug && !hash) || isProductDisplayPage)
    ) {
      if (window) {
        window.scrollTo(0, 0)
      }
      lastLocationPath.current = pathname
      lastSearchString.current = search
    }
  }, [pathname, search, params, hash, isProductDisplayPage])
}

export default useScrollToTopOnNewLocation
